<style lang="less">
	ul{
		list-style: none;
		padding-left: 0 !important;
	}
	a.icon{
		text-decoration: none;

	}
</style>
<template>
	<div>

		<h2 class="mw-h1">{{project.clientName}}</h2>
						<p>{{project.description}}</p>
		<v-card>
			<v-tabs
				v-model="tab"
				background-color="white"
				color="black"
				right 
				show-arrows
				pagination
				:icons-and-text="true"
			>
				<v-tabs-slider></v-tabs-slider>

				<v-tab href="#informationTab">
					Project Info <v-icon>mdi-information</v-icon>
				</v-tab>
				<v-tab href="#appointmentsTab">
					Appointments<v-icon>mdi-calendar-outline</v-icon>
				</v-tab>
				<v-tab href="#calendarTab">
					Calendar<v-icon>mdi-calendar-month</v-icon>
				</v-tab>
				<v-tab href="#profilesTab">
					Profiles<v-icon>mdi-clipboard-account-outline</v-icon>
				</v-tab>
				<v-tab href="#downloadsTab">
					Downloads<v-icon>mdi-folder-download</v-icon>
				</v-tab>
				<v-tab href="#recordingsTab" v-if="!organisation.hideRecordings">
					Recordings<v-icon>mdi-file-music</v-icon>
				</v-tab>

				<v-tab href="#invoiceTab" v-if="showInvoices">
					Invoices<v-icon>mdi-currency-gbp</v-icon>
				</v-tab>


				<v-tab-item value="invoiceTab">
					<StorageList name="Invoices" :allowUpload="false" :folder="invoicePath" :folders="[]"></StorageList>	
				</v-tab-item>
				<v-tab-item value="informationTab">
					<v-card flat tile>
					<v-container>
						<v-row justify="space-between">

							<v-col cols="12" md="5">
								<h4>Contacts</h4>
									<div v-for="user in projectManagers" :key="user.id">
										<span class="font-weight-light mr-2 pt-2" style="font-size: 1.2em">{{user.displayName}}</span>
										<a class="icon" v-bind:href="'mailto:'+user.email"><v-icon>mdi-mail</v-icon></a>
									</div>
									<div v-if="orderedDates.length">
										<h4>Timeline</h4>
										<ul class="font-weight-light" v-for="(date, i) in orderedDates" :key="i">
											<li>{{prettyPrint(date.text, "TITLE")}}: {{ date.date.toDate() | moment("dddd, MMMM Do YYYY") }}</li>
										</ul>
									</div>
							</v-col>
							<v-col cols="12" md="7">
								<ProgressStats 
								:toggleStatOptions="false"
								:project="project"></ProgressStats>
							</v-col>
						</v-row>
					</v-container>
					</v-card>
				</v-tab-item>
				<v-tab-item value="appointmentsTab">
					<v-card flat tile>
						<v-row>
							<v-col class="pa-5">
								<MwDataTable 
								:showSelect="true"
								:editable="false" 
								:allowExport="true"
								:exportName="exportName"
								:columns="appointmentTableColumns"
								:rows="appointmentTableRows"
								v-on:change="multiSelected"
								itemKey="id"
								v-on:startVideo="startVideo"
								v-on:startPhone="startPhone"
								v-on:update="updateValue"
								v-on:appointmentComments="appointmentComments">
								</MwDataTable>
								<v-dialog v-model="showStartVideo" width="400">
									<StartVideo :appointment="focusAppointment"></StartVideo>
								</v-dialog>
								<v-dialog v-model="showStartPhone" width="400">
									<StartPhone :appointment="focusAppointment"></StartPhone>
								</v-dialog>
								<v-dialog v-model="showAppointmentFeedback" width="500">
									<AppointmentComments :appointment="focusAppointment" v-on:close="showAppointmentFeedback = false"></AppointmentComments>
								</v-dialog>
								<v-dialog v-model="showSendMessageDialog" width="500">
									<SendCustomMessage 
									:anonymous="view == 'client'"
									:from="user.uid" 
									:to="selected.map( m => m.participant )" 
									v-on:cancel="showSendMessageDialog = 0"
									v-on:sent="messageSent"
									></SendCustomMessage>
								</v-dialog>
								<v-snackbar v-model="showMessageSent" light>
									{{messageFeedback}}
								<v-btn color="green" text @click="showMessageSent = false">Close </v-btn>
								</v-snackbar>

								<p class="text-right"><v-btn :disabled="!selected.length" color="primary" class="mr-3" @click="showSendMessageDialog = 1">Send Message</v-btn></p>
							</v-col>
						</v-row>
					</v-card>
				</v-tab-item>
				<v-tab-item value="calendarTab">
					<v-card flat tile>
						<v-card-text> 
							<Calendar :allowAddAvailability="true" v-on:availabilitySet="updateAvailability" :availability="projectAvailabilityEvents" :events="calendarEvents" :toggles="toggles" v-on:clickedEvent="viewEvent"></Calendar>
						</v-card-text>
					</v-card>
				
					<div class="ma-3" v-if="showAppointmentDialog">
						<v-dialog v-model="showAppointmentDialog"  transition="dialog-bottom-transition"  max-width="800px">
							<v-card class="pa-3">
								<v-btn absolute right icon @click="showAppointmentDialog = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
								<ViewAppointment :appointment="focusAppointment" :hideButtons="true"></ViewAppointment>
							</v-card>
						</v-dialog> 
					</div>
				</v-tab-item>
				<v-tab-item value="profilesTab" v-if="project.screener">
					<v-card flat tile>
						<v-card-text> 
							<SurveyResponses :project="project" :survey="screener" :limitParticipants="appointments.map( a => a.participant )"></SurveyResponses>
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item value="downloadsTab">
					<v-card flat tile>
						<v-card-text> 
							<StorageList :allowUpload="showUpload" :folder="projectFolder"></StorageList>
						</v-card-text>
					</v-card>
				</v-tab-item>
				<v-tab-item value="recordingsTab" v-if="!organisation.hideRecordings">
					<v-card flat tile>
						<v-card-text> 
							<RecordingsList :project="project"></RecordingsList>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs>
		</v-card>
	</div>
</template>

<script>

	import Vue from "vue";
	import Vuex from 'vuex'
	

	import {prettyPrint, sortByKey, formatDateTime } from "../../assets/utilities.js";
	import {visibleDisplayName, visibleContacts} from "../../assets/permissionsFunctions.js"

	import {userTimezone} from "../../assets/timezoneFunctions.js"
	import  MwDataTable from "../tools/MwDataTable";
	import  StartVideo from "../communication/video/StartVideo";
	import  StartPhone from "../communication/video/StartPhone";
	import  AppointmentComments from "../tools/AppointmentComments";
	import  Calendar from "../tools/Calendar";
	import 	ViewAppointment from "../singles/ViewAppointment.vue";
	import 	SurveyResponses from "../tools/SurveyResponses.vue";
	import  SendCustomMessage from "../tools/SendCustomMessage.vue";
	import 	StorageList from "../tools/StorageList.vue"
	import 	ProgressStats from "../tools/ProgressStats.vue";
	import RecordingsList from "@/components/subpanels/RecordingsList"


	export default{
		name: "ViewProject",
		components: {
			MwDataTable,
			StartVideo,
			StartPhone,
			RecordingsList,
			AppointmentComments,
			Calendar,
			SurveyResponses,
			ViewAppointment,
			SendCustomMessage,
			StorageList,
			ProgressStats
		},
		props: {
			project: {type: Object},
			hideButtons: {type: Boolean, default: false }
		},
		data: () => {
			return {
				showAppointmentDialog: false,				
				focusAppointment: false,
				showAppointmentFeedback: false,
				showStartVideo: false,
				tab: "", 
				showMessageSent: false,
				showSendMessageDialog: false,
				messageFeedback: 'Message sent',
				selected: []
			}
		},
		computed: {
			...Vuex.mapState({
				user: function(state) {
					return state.auth.user	 
				},
				userDetails: function(state) {
					return state[state.auth.view].user	 
				},
				organisation(state){
					if( !this.userDetails || !this.userDetails.organisation ){
						return;
					}
					else{
						var client = this.userDetails.organisation
						return state[state.auth.view].organisations.find( o => o.id == client )
					}
				},
				invoicePath(){
					return "organisations/"+this.project.client+"/invoices/"+this.project.id
				},
				projectFolder(){
					return "projects/"+this.project.id+"/client"
				},
				appointments: function(state) {
					const self = this;
					return state[state.auth.view].appointments.filter( a => a.project == self.project.id)
				},
				projectManagers: (state) => {return state[state.auth.view].admins; },
				projectAvailability: function(state){ 
					const self = this;
					let a = state[state.auth.view].projectAvailability.filter( a => a.id == self.project.id);
					if( a ){
						return a[0]
					}
				},
				screener: function(state){ 
					const self = this;
					if( !self.project ){ return; }
					return state[state.auth.view].surveys.find(a => a.id == self.project.screener ) 
				},
				participants: (state) => {return state[state.auth.view].panelists; },
			}),			
			orderedDates: function(){
				let dates = [];
				for( var key in this.project.dates ){
					if( this.project.dates[key] ){
						let date = { text: key, seconds: this.project.dates[key].seconds, date: this.project.dates[key] }
						dates.push( date ) 
					}
				}
				return sortByKey( dates, "seconds")
			},
			projectAvailabilityEvents: function(){  
				const self = this;
				if( !self.projectAvailability ){ return; }
				let events = []
				let availabilities = self.projectAvailability[self.user.uid];
				if( availabilities ){
					availabilities.forEach( function(e){
						if( e.start_date ){
							if( !e.start_time ){
								e.start_time = "00:00"
							}
							if( !e.end_time ){
								e.end_time = "00:00"
							}
							events.push({
								name: self.user.displayName + " available", 
								availability: true, 
								start: e.start_date + " " + e.start_time,
								end: e.end_date + " " + e.end_time,
								userId: self.user.uid
							})
						}
					} )
				}
				return events;
			},
			appointmentTableRows: function(){
				let self = this;
				if(!self.appointments){
					return;
				}
				return self.appointments.map( a => {
					let appointmentId = a.id;
					let a2 = {...a, id: appointmentId}
					let participant = this.participants.find( r => r.id == a.participant  );
					if( a2.dateTime ){
						a2.date = Vue.moment(a2.dateTime.toDate()).tz(userTimezone(self.userDetails)).format("YYYY-MM-DD")
						a2.time = Vue.moment(a2.dateTime.toDate()).tz(userTimezone(self.userDetails)).format("HH:mm")
					} 
					if( a2.additionalFields ){					
						for( var field in a2.additionalFields) {
							a2[field] = a2.additionalFields[field];
						}
					}						
					if( participant ){
						a2.displayName = visibleDisplayName(this.user, participant, this.project);
						a2.email = visibleContacts(this.user, participant, this.project, "email");
						a2.phone = visibleContacts(this.user, participant, this.project, "phone");
					}
					if( !a2.feedback ){
						a2.feedback = {}
					}
					a2.createdFormatted = Vue.moment(a2.created.toDate()).tz(userTimezone(self.userDetails)).format("DD/MM/YYYY HH:mm")
					return a2
				})
			},
			appointmentTableColumns: function(){
				var self = this;
				let columns = [
					{ type: "text", value: "createdFormatted", text: "Created"},
					{ type: "text", value: "date", text: "Date"},
					{ type: "text", value: "time", text: "Time"},
					{ type: "text", value: "displayName", text: "Participant"},
					{ text: 'Consent', value: 'consentGranted' },
					{ type: "text", value: "quota", text: "Quota"},
					{ type: "text", value: "status", text: "Status"}
				];
				if( !self.project.hideContactDetails ){
					let email = { type: "text", value: "email", text: "Email"};
					let phone = { type: "text", value: "phone", text: "Phone"}
					// TODO 
					// Becca later on we're going to want to add some 
					// if( self.project.blurDetails ){
					// 	phone.blur = "blur";
					// 	email.blur = "blur" ;
					// }
					columns.push(email, phone)
				}
				if( self.project.additionalFields ){					
					self.project.additionalFields.forEach( field =>{
						columns.push( { type: "text", value: field, text: prettyPrint(field, "TITLE") } )
					})
				}
				columns.push({ 
					text: 'Attended',
					value: 'participantAttended',
					type: 'switch',
					inline: "always"
				})
				if( !self.hideButtons  ){
						
					if(  self.project.includeCalling ){
						columns.push({ type: "button", value: "startPhone", color: "green", text: "Call"})
					}
					if( self.project.includeVideoCalling ){
						columns.push({ type: "button", value: "startVideo", color: "green", text: "Video"})
					}
					columns.push({ type: "button", value: "appointmentComments", color: "green", text: "Comments"})

				}
				return columns;
			},
			exportName: function(){
				return this.project.clientName + " - Participants.xls"; 
			},
			calendarEvents: function(){
				const self = this;
				const events = [];
				self.appointmentTableRows.forEach( function(row){
					if( !row.dateTime ){ return; }
					let event = {...row};
					event.appointment = row.id;
					if( !event.time ){
						event.time = "00:00";
					}
					event.start = event.date + " " + event.time;
					event.name = event.displayName;
					if( !event.name ){
						event.name = '';
					}
					if( event.duration ){
						let end = event.dateTime.seconds + (60 * event.duration);
						event.end = end;

					}
					events.push( event )
				})
				return events
			},
			toggles: function(){
				let toggles = ['quota']
				toggles = toggles.concat(this.project.additionalFields )
				return toggles;
			},
			showInvoices(){
				if( !this.project.permissions ){
					return false;
				}
				if( this.project.permissions[this.user.uid]["view-invoices"] ){
					return true;
				}
				return false;
			},
			showUpload(){
				if( !this.project.permissions ){
					return false;
				}
				if( this.project.permissions[this.user.uid]["upload"] ){
					return true;
				}
				return false;
			}
		},
		methods:{
			prettyPrint: prettyPrint,
			multiSelected: function(value){
				this.selected = value;
			},				
			viewEvent: function(appointmentId){
				this.focusAppointment = this.appointments.find( a => a.id == appointmentId )
				this.showAppointmentDialog = 1;
			},
			appointmentComments: function(row){
				this.focusAppointment = row;
				this.showAppointmentFeedback = 1;
			},
			startVideo: function(row){
				this.focusAppointment = row;
				this.showStartVideo = 1;
			},
			startPhone: function(row){
				this.focusAppointment = row;
				this.showStartPhone = 1;
			},
			messageSent(message){
				this.messageFeedback = message;
				this.showSendMessageDialog = 0;
				this.showMessageSent = 1;

			},
			updateValue(object, key){
				var data = {};
				data[key] = object[key];
				var update = {
					doc: "appointments/"+ object.id,
					data: data, 
					action: "update"
				}
				this.$store.dispatch("updateDoc", update)
			},
			updateAvailability: function(events){
				const self = this;
				let uid = self.user.uid;
				let	availabilities = []
				events.forEach( function(event){
					let startDateTime = formatDateTime(event.start_date, event.start_time);
					let endDateTime = formatDateTime(event.end_date, event.end_time);
					availabilities.push({
						...event,
						startDateTime,
						endDateTime
					})
				} )
				let update = {}
				update[uid] = availabilities;
				self.$store.dispatch("getDoc", {
					doc: "projectAvailability/"+ self.project.id
					}).then( doc => {
					var action = "update";
					if( !doc.exists ){
						action = "set";
					}
					self.$store.dispatch("updateDoc", {
						doc: "projectAvailability/" + self.project.id,
						action: action,
						data: update
					})
				})
			}
		},
		watch: {
			project: {
				immediate: true,
				handler: function( ){
					this.$store.dispatch("bindProject", this.project.id )
				}
			}
		},
		destroyed: function(){

		}
	}
</script>